export default __webpack_public_path__ + "static/media/gelidbones.85251d22.png";